import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ConvertorMiladi } from 'utilities/helper/digitToMonth'
interface ISubHeaderProps {
    data: ISubHeaderLoan
    setIsOpenLink: React.Dispatch<React.SetStateAction<boolean>>
}
export default function SubHeader({ data, setIsOpenLink }: ISubHeaderProps) {
    const navigate = useNavigate()
    return (
        <div className="bg-white px-4 pt-2 pb-4">
            <div className="flex flex-col gap-2.5 py-2">
                <div className="flex justify-between items-baseline">
                    <p className="text-sm text-text-secondary">مبلغ وام</p>
                    <p className="text-base font-bold text-black">
                        {data.amount && data.amount.toLocaleString()} تومان
                    </p>
                </div>
                <div className="flex justify-between items-baseline">
                    <p className="text-sm text-text-secondary">
                        تاریخ اعطای وام
                    </p>
                    <p className="text-sm font-bold text-black">
                        {data.pay_date && ConvertorMiladi(data.pay_date)}
                    </p>
                </div>
                <div className="flex justify-between items-baseline">
                    <p className="text-sm text-text-secondary">
                        نحوه دریافت کارمزد
                    </p>
                    <p className="text-sm font-bold text-black">
                        {data.interest_pay_mode === 'lip_ma'
                            ? 'افزودن به هر قسط' +
                              `(${Number(data.interest_rate) * 100} درصد)`
                            : 'کسر از مبلغ وام'}
                    </p>
                </div>
                <div className="flex justify-between items-baseline">
                    <p className="text-sm text-text-secondary">
                        اقساط پرداخت شده
                    </p>
                    <p className="text-sm font-bold text-black">
                        {data.number_of_repaid_installments} قسط
                    </p>
                </div>
                <div className="flex justify-between items-baseline">
                    <p className="text-sm text-text-secondary">
                        اقساط باقی مانده
                    </p>
                    <p className="text-sm font-bold text-black">
                        {data.number_of_repayments} قسط
                    </p>
                </div>
                <div className="flex justify-between items-baseline">
                    <p className="text-sm text-text-secondary">اقساط معوق</p>
                    <p className="text-sm font-bold text-error-3">
                        {data.number_of_delayed_installments} قسط
                    </p>
                </div>
            </div>
            <div className="flex flex-col gap-2 mt-4">
                <button
                    className="bg-green-1 text-white rounded-card font-bold h-10 px-4 active:scale-[0.98] w-full text-sm"
                    onClick={() => navigate(-1)}
                >
                    اطلاعات عضو
                </button>
                <button
                    className="bg-green-1 text-white rounded-card font-bold h-10 px-4 active:scale-[0.98] w-full text-sm"
                    onClick={() => setIsOpenLink(true)}
                >
                    اشتراک گذاری لینک پرداخت اقساط وام
                </button>
            </div>
        </div>
    )
}
